import { useEffect } from "react";
import {
  createFileRoute,
  Outlet,
  Link,
  useNavigate,
} from "@tanstack/react-router";
import { useNetworkState } from "@uidotdev/usehooks";
import { aws } from "@/helpers/aws";

// Helpers
import { clearLocalStorage } from "@/helpers/accessLocalStorage";

// UI
import AlertModal from "@/components/AlertModal";
import { Button } from "@/components/ui/button";

import { Badge } from "@/components/ui/badge";
import { AUTH_KEY } from "@/constants/local-storage-key";
// Icons
import { LogOut, Wifi, WifiOff, MessagesSquare } from "lucide-react";

// Constants
import siteConfig from "@/config/site";

// zustand
import { useDocumentStore } from "@/zustand/documentStore";

import { version } from "../../package.json";
export const Route = createFileRoute("/_layout-private")({
  component: SideBar,
});

function SideBar() {
  const network = useNetworkState();
  const navigate = useNavigate();
  const userString = localStorage.getItem(AUTH_KEY);
  const userJson = userString ? JSON.parse(userString) : null;

  const { fetchDocuments } = useDocumentStore();

  const findBy = {
    limit: 100,
    skip: 0,
  };

  useEffect(() => {
    fetchDocuments(findBy);
  }, [fetchDocuments]);

  useEffect(() => {
    const savedToken = localStorage.getItem(AUTH_KEY); // Replace with your key
    if (!savedToken) {
      navigate({
        to: "/",
        search: {
          active: "riskAssessment",
        },
      });
    }
  }, [navigate]);
  console.log(aws + userJson?.profileUrl, "profileUrl");
  // Function
  const handleLogout = () => {
    clearLocalStorage();
    navigate({
      to: "/",
      search: {
        active: "riskAssessment",
      },
    });
  };

  const getNetworkQuality = () => {
    if (!network?.online)
      return {
        status: "ຂາດການເຊື່ອມຕໍ່ອິນເຕີເນັດ",
        color: "text-red-500",
        icon: WifiOff,
      };

    // Based on effectiveType
    if (network.effectiveType === "4g") {
      return {
        status: "ເຊື່ອມຕໍ່ດ້ວຍຄວາມໄວສູງ",
        color: "text-green-500",
        icon: Wifi,
      };
    }
    if (network.effectiveType === "3g") {
      return {
        status: "ເຊື່ອມຕໍ່ດ້ວຍຄວາມໄວປານກາງ",
        color: "text-yellow-500",
        icon: Wifi,
      };
    }
    if (network.effectiveType === "2g" || network.effectiveType === "slow-2g") {
      return {
        status: "ເຊື່ອມຕໍ່ດ້ວຍຄວາມໄວຕ່ຳ",
        color: "text-orange-500",
        icon: Wifi,
      };
    }

    // Fallback based on downlink if effectiveType is not available
    if (network.downlink) {
      if (network.downlink > 5) {
        return {
          status: "ເຊື່ອມຕໍ່ດ້ວຍຄວາມໄວສູງ",
          color: "text-green-500",
          icon: Wifi,
        };
      }
      if (network.downlink > 2) {
        return {
          status: "ເຊື່ອມຕໍ່ດ້ວຍຄວາມໄວປານກາງ",
          color: "text-yellow-500",
          icon: Wifi,
        };
      }
      return {
        status: "ເຊື່ອມຕໍ່ດ້ວຍຄວາມໄວຕ່ຳ",
        color: "text-orange-500",
        icon: Wifi,
      };
    }

    // Default fallback
    return {
      status: "ເຊື່ອມຕໍ່ອິນເຕີເນັດແລ້ວ",
      color: "text-green-500",
      icon: Wifi,
    };
  };

  const networkQuality = getNetworkQuality();

  return (
    <div className="flex flex-row h-screen">
      <aside className="w-[20%] h-full border-r bg-primary flex flex-col">
        <div
          className="flex flex-col items-center flex-shrink-0 w-full gap-4 p-4"
          style={{
            boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.1)",
          }}
        >
          <img src="/soei_logo.png" alt="logo" width={64} height={64} />

          <div className="flex flex-col items-center justify-center gap-1">
            <h2 className="text-sm font-bold text-white">
              ລະບົບ ຄຸ້ມຄອງວິສາຫະກິດລັດລົງທຶນ
            </h2>

            <small className="font-semibold text-white">
              ກົມຄຸ້ມຄອງວິສາຫະກິດລັດລົງທຶນ ແລະ ການປະກັນໄພ
            </small>
            {/* <h3 className="text-sm text-white">ກະຊວງການເງິນ</h3> */}
          </div>
        </div>
        <nav className="mt-[40px] px-4 flex-1 overflow-y-auto">
          {siteConfig.sideBarMenus.map((menu) => (
            <div key={menu.title}>
              <h4 className="px-4 py-2 text-[10px] text-gray-300 font-semibold">
                {menu.title}
              </h4>
              <ul>
                {menu.navItems.map((navItem) => (
                  <li key={navItem.name}>
                    <Link
                      to={navItem.link}
                      className="px-4 py-2 rounded-md text-white flex items-center [&.active]:font-bold [&.active]:bg-muted [&.active]:text-primary  text-[14px] "
                    >
                      <navItem.icon className="mr-2" size={20} />
                      {navItem.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div className="flex flex-col space-y-1 my-3 text-center text-sm text-white">
            <p>Version {version}</p>
          </div>
        </nav>
      </aside>
      <div className="relative w-[80%] h-screen overflow-y-auto  ">
        <header className="sticky top-0 z-10 flex items-center justify-between w-full px-8 py-4 bg-white border-b">
          <div>
            <Badge
              variant={"secondary"}
              className="flex items-center gap-2 px-3 py-1"
            >
              <div
                className={`flex gap-2 items-center ${networkQuality.color}`}
              >
                <networkQuality.icon className="w-4 h-4" />
                <span>{networkQuality.status}</span>
                {network?.downlink && (
                  <span className="ml-1 text-xs">
                    ({network.downlink.toFixed(1)} Mbps)
                  </span>
                )}
              </div>
            </Badge>
          </div>
          <div className="space-x-[24px] flex items-center">
            <Button
              onClick={() =>
                navigate({
                  to: "/chat",
                })
              }
            >
              <MessagesSquare size={20} className="mr-2" />
              ການສົນທະນາ
            </Button>

            <AlertModal
              title="ທ່ານແນ່ໃຈບໍ ທີ່ຈະອອກຈາກລະບົບ?"
              triggerComponent={
                <Button variant={"outline"}>
                  <LogOut size={20} className="mr-2" />
                  ອອກຈາລະບົບ
                </Button>
              }
              confirmFunction={handleLogout}
            />
          </div>
        </header>
        <main className="py-[24px] px-[32px] ">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
